import React, { useState } from 'react'
import ModalAlert from './ModalAlert'

export default function LogoutButton({ logoutPath, className = '' }) {
  const [showConfirmation, setShowConfirmation] = useState(false)

  function submitLogout() {
    const form = document.createElement('form')
    const methodInput = document.createElement('input')
    const csrfToken = document.querySelector('meta[name="csrf-token"]')?.content

    form.method = 'post'
    form.action = logoutPath
    form.style.display = 'none'

    methodInput.type = 'hidden'
    methodInput.name = '_method'
    methodInput.value = 'delete'
    form.appendChild(methodInput)

    if (csrfToken) {
      const tokenInput = document.createElement('input')

      tokenInput.type = 'hidden'
      tokenInput.name = 'authenticity_token'
      tokenInput.value = csrfToken
      form.appendChild(tokenInput)
    }

    document.body.appendChild(form)
    form.submit()
  }

  return (
    <>
      <button
        type='button'
        className={className}
        onClick={() => setShowConfirmation(true)}
      >
        {Cas.translations.logout_button}
      </button>

      { showConfirmation &&
        <ModalAlert
          mode='small logout-confirmation-modal'
          cancelText={Cas.translations.cancel}
          acceptText={Cas.translations.logout_confirm_action}
          onClose={() => setShowConfirmation(false)}
          onSelect={submitLogout}
          alert={
            <div>
              <div className='bold'>{Cas.translations.logout_confirm_title}</div>
              <div>{Cas.translations.logout_confirm_message}</div>
            </div>
          }
        />
      }
    </>
  )
}
